/**
 * Debounce given function
 * @param fn {function()}
 * @param delay
 * @returns {(function(): void)|*}
 */
export function debounce (fn, delay = 500) {
    let timeoutID = null
    return function () {
        clearTimeout(timeoutID)
        let args = arguments
        let that = this
        timeoutID = setTimeout(function () {
            fn.apply(that, args)
        }, delay)
    }
}
